import { render, staticRenderFns } from "./ProductInformationImport.vue?vue&type=template&id=6cfba0fd&scoped=true"
import script from "./ProductInformationImport.vue?vue&type=script&lang=js"
export * from "./ProductInformationImport.vue?vue&type=script&lang=js"
import style0 from "./ProductInformationImport.vue?vue&type=style&index=0&id=6cfba0fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfba0fd",
  null
  
)

export default component.exports